import React from 'react'
import { StateParagraph } from '../ItineraryImportPage.styles'
import CenteredState from './CenteredState'
import { RotateCcw } from './icons'

const StuckBody: React.FC = () => (
	<CenteredState
		tone="gold"
		icon={<RotateCcw size={40} strokeWidth={1.8} />}
		headline="This one's been stuck a while"
	>
		<StateParagraph>
			Your import has been processing for over 10 minutes — most likely something hiccuped on our
			end. Your trip wasn't changed. Want to retry?
		</StateParagraph>
	</CenteredState>
)

export default StuckBody
